export const appConfig = {
	name: "RESUME",
	API_ROOT: process.env.REACT_APP_BASE_URL,
};
